module.exports = __webpack_public_path__ + "img/s6e.de81a008.jpg";